import { useMemo } from 'react';

//@ts-expect-error untyped dependency
import { ReportingIngestionInteraction } from 'reporting-data/monitoring/ingestion';
const useReportingIngestionInteraction = (report, reportIngestionOptions) => {
  return useMemo(() => {
    return new ReportingIngestionInteraction(report, reportIngestionOptions);
  }, [report, reportIngestionOptions]);
};
export default useReportingIngestionInteraction;